import moment from 'moment';
import { useEffect, useState } from 'react';
import Util from 'service/util';

const today = Util.getToday();

const ServiceSelectModeBar = ({start_a1, vehicle, showModal}) => {

  const [v, setVehicle] = useState(vehicle);
  const S = showModal;
  const a = v.activeService;

  useEffect(() => {
    setVehicle(vehicle);
  }, [vehicle]);

  let curActiveMaxDate = new Date(v.services?.reduce((r,x) => x.end_dtm?.valueOf() > r ? x.end_dtm.valueOf() : r, 0));
  if (curActiveMaxDate.valueOf() > 0) curActiveMaxDate.setHours(24,0,0,0);

  // future service
  let f = v.services?.find(x => moment(x.start_dtm).isAfter(today))||null;

  if (!a)
  {
    // case 4 - inactive no future service
    if (!f) return <button className="btn green" onClick={e=>S('add', curActiveMaxDate)}>建立新服務</button>
    // case 5 - inactive but future service is determined, no buttons should be provided
    else return '';
  }
  else if (!a.end_dtm)
  {
    // case 1 - active service, with no end
    return <>
      <button className="btn red" onClick={e=>S('susp', start_a1, a)}>暫停服務</button>
      <button className="btn red" onClick={e=>S('term', start_a1, a)}>終止服務</button>
    </>
  }
  else
  {

    if (null == f)
    {
      // case 2 - active service, with end, no future update
      return <button className="btn green" onClick={e=>S('add', curActiveMaxDate, null)}>建立新服務</button>
    }
    else
    {
      // case 3 - active service, with end, with future update
      //   check if all services has determined termination, if yes allow adding new future events
      if (v.services) {
        for (let i = 0; i < v.services.length; i++)
        {
          if (!v.services[i].end_dtm) return ''; // if any no-end service exists, do not allow creating new services
        }
        // all services are determined with end date
        return <button className="btn green" onClick={e=>S('add', curActiveMaxDate, null)}>建立新服務</button>
      }
      return ''; // change not allowed, remove future event first
    }
  }

}

export default ServiceSelectModeBar;